<template>
  <div class="consult-detail container">
    <div class="header">
      <el-breadcrumb class="breadcrumb" separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/consult/list' }">参考书</el-breadcrumb-item>
        <el-breadcrumb-item>参考书详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <div class="status">
            <span class="label">发布状态：</span>
            <el-switch v-model="consult.status" @change="updateConsultStatus"></el-switch>
          </div>
        </div>
        <div class="right">
          <el-button type="primary" @click="handleToPreview">预览</el-button>
        </div>
      </div>
    </div>
    <ConsultInfo class="info-card" :content="consult" @submit="fetchConsultInfo" />
    <div class="main">
      <div class="card-header">
        <h3 class="title">题库</h3>
      </div>
      <div class="table-wrap">
         <div class="values">
          <ExamCard class="exam-item" :content="item" @remove="handleConsultExamRemove" v-for="item in exams" :key="item.id"/>
          <div class="add-wrap" @click="handleContentChoose">
            <i class="el-icon-plus"></i>
            <span>添加题库</span>
          </div>
        </div>
      </div>
    </div>
    <ContentChoose
      :visible="contentChooseDialog"
      :filter_ids="exams.map(v => v.id)"
      @close="contentChooseDialog = false"
      @submit="handleContentChooseSave"
      :ref_type="2"
    ></ContentChoose>
  </div>
</template>

<script>
import ExamCard from '@/components/card/ConsultExam'
import ContentChoose from "@/components/dialog/ContentChoose";
import ConsultInfo from '@/components/card/ConsultInfo'
import { consultOne, consultUpdateStatus, consultContent, consultExamList, consultExamCreate,
consultExamUpdate, consultExamDestroy } from '@/api/consult'

export default {
  components: {
    ExamCard,
    ConsultInfo,
    ContentChoose
  },
  data() {
    return {
      contentChooseDialog: false,
      consult: {},
      exams: []
    }
  },
  created() {
    this.fetchConsultInfo()
    this.fetchConsultExamList()
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    // 课程基本信息
    fetchConsultInfo() {
      consultOne({id: this.$route.params.consultId}).then(res => {
        this.consult = res
        this.consult.status = this.consult.status == 1 ? true : false
      })
    },
    // 参考书基本信息
    fetchConsultExamList() {
      consultExamList({consult_id: this.$route.params.consultId}).then(res => {
        this.exams = res.list || []
      })
    },
    // 更新题库在线状态
    updateConsultStatus() {
      consultUpdateStatus({id: this.$route.params.consultId, status: this.consult.status ? 1 : 0}).then(res => {
        this.$message.success(`发布状态更新成功`)
      }).catch(error => {
        console.log('error: ', error)
      })
    },
    // 题库删除
    handleConsultExamRemove(examId) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        consultExamDestroy({product_id: examId, consult_id: this.$route.params.consultId}).then(res => {
          this.$message.success(`删除成功`)
          this.fetchConsultExamList()
        })
      }).catch(() => {})
    },
    handleContentChoose() {
      this.contentChooseDialog = true
    },
    handleContentChooseSave(value) {
      console.log(value)
      consultExamCreate({consult_id: this.$route.params.consultId, product_id: value.id}).then(res => {
        this.fetchConsultExamList()
      })
    },
    // 页面滚动到顶部
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    // 预览
    handleToPreview() {
      // if (this.exam && this.exam.subjects && this.exam.subjects[0]) {
      //   if (location.host.includes('admin.koudaikaoyan.com')) {
      //     window.open(`https://www.koudaikaoyan.com/subject/${this.exam.subjects[0].id}/exercise/${this.exam.id}`)
      //   } else {
      //     window.open(`http://test.koudaikaoyan.com/subject/${this.exam.subjects[0].id}/exercise/${this.exam.id}`)
      //   }
      // }
    }
  },
  directives: {
    focus: {
      // 指令的定义
      inserted: function (el, {value}) {
        if (value) {
          el.focus()
        }
      },
      update: function (el, {value}) {
        if (value) {
          el.focus()
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.consult-detail {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .info-card {
    margin-top: 10px;
  }
  .main {
    color: #303133;
    background-color: #FFF;
    border: 1px solid #EBEEF5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    padding: 20px;
    overflow: hidden;
    margin-top: 10px;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
  }
  .table-wrap {

    .values {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      margin-right: -15px;
    }
    .exam-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .add-wrap {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 260px;
      height: 201px;
      color: #303133;
      background-color: #FFF;
      border: 1px solid #EBEEF5;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      border-radius: 4px;
      overflow: hidden;

      i {
        font-size: 32px;
        color: #999;
      }
      span {
        color: #999;
        margin-top: 10px;
      }
    }
  }
}
</style>
